import { expValEquals } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

export function getApolloRelayCacheBridgeDisabledReason(): string | null {
	if (StatsigConfigurations.getBoolean('confluence_relay_rollout_force_apollo', false)) {
		return 'apollo-forced';
	}

	if (!expValEquals('confluence_apollo_relay_cache_bridge', 'isEnabled', true)) {
		return 'apollo-relay-cache-bridge-disabled';
	}

	return null;
}
